type QueryParamScalar = string | number | boolean | null | undefined;

type QueryParamValue =
	| QueryParamScalar
	| ReadonlyArray<string | number | boolean>;

export const createQueryParams = (
	paramsObject: Record<string, QueryParamValue>,
) => {
	const params = new URLSearchParams();
	Object.entries(paramsObject).forEach(([key, value]) => {
		if (value === undefined || value === null) return;
		if (Array.isArray(value)) {
			if (value.length === 0) return;
			params.append(key, value.join(','));
			return;
		}
		params.append(key, value.toString());
	});
	return params;
};
